#import "../../../../power-ai/timeline-summary/graphql/fragments/entity-summary-fragment.graphql"

fragment ExternalMeetingFragment on ExternalMeeting {
    id
    type
    topic
    durationMinutes
    duration {
        formatted
        formattedString
        value
    }
    transcript
    transcriptionSummary {
        ...EntitySummaryFragment
    }
    transcriptStatus
    startTime
    participants {
        name
        emailAddress {
            display
            address
            avatarEntity {
                id
                name
                avatarUrl
                initials
                htmlUrl
            }
        }
    }
    recordingStatus
    recordingUrl
    activity {
        id
        name
        startTime
        participants {
            id
            name
            type
            htmlUrl
            htmlUrlPath
            primaryEmailAddress
            primaryPhoneNumber
        }
        durationMinutes
        duration {
            formatted
            formattedString
            value
        }
        summary {
            ...EntitySummaryFragment
        }
    }
    isProcessing
}
